import "../stylesheets/App.css";
import "../stylesheets/Error404.css";
import React, { useEffect } from "react";

function ErrorAuth() {
  useEffect(() => {
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "hidden";
  }, []);

  return (
    <>
      <div className="error-container">
        <div className="div-404-flotante">
          <h1 className="error-404">404</h1>
        </div>

        <div className="popup-error">
          <div className="orange-div">error</div>
          <div className="white-div">
            <h1>Error de autentificación</h1>
            <p>Por favor solicite un nuevo código QR para ingresar</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ErrorAuth;
